import React from 'react'

import { COLORS } from '~/common/globalStyles'

interface Props {
  width?: string
  fill: keyof typeof COLORS
  Svg: React.ComponentType<any>
}

const LogoIcon = ({ Svg, width, fill }: Props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width={width}
    height={30}
  >
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 184.95 184.93"
    >
      <defs></defs>
      <g id="Layer_1-2" fill={fill}>
        <path
          className="cls-1"
          d="M0,0V184.93H184.95V0H0ZM155.29,71.51h-6.94s-.04,.02-.04,.02h-55.84c-11.55,0-20.95,9.38-20.95,20.93s9.4,20.93,20.95,20.93h34.9v7.12h-.02c-.07,3.8-3.14,6.85-6.96,6.85h-27.92c-19.25,0-34.9-15.65-34.9-34.9s15.65-34.9,34.9-34.9h62.82v13.95Zm0-27.98h-6.25c-.23,0-.47,.05-.72,.05h-55.84c-26.95,0-48.87,21.92-48.87,48.87s21.92,48.87,48.87,48.87h27.92c11.55,0,20.95-9.4,20.95-20.95v-20.95h-48.87c-3.85,0-6.98-3.13-6.98-6.98s3.13-6.98,6.98-6.98h62.82v34.9c0,19.25-15.65,34.88-34.9,34.88h-27.92c-34.63,0-62.82-28.16-62.82-62.8S57.85,29.66,92.47,29.66h62.82v13.88Z"
        />
      </g>
    </svg>
  </Svg>
)

export default LogoIcon
